import Image from "next/image";
import localeCore from "../../core/locale.core";
import { useShopFull } from "../../hooks/useShop.hook";
import { Media } from "../../types/media";

export default function ClientLogo() {
  const { data: shop } = useShopFull();

  if (!shop || !shop.logoMedia) return null;

  const { width, height } = getComputedImageDimensions(60, shop.logoMedia);

  return (
    <section className="flex gap-3 items-center">
      <h1>{localeCore.getLocaleValueDefault(shop.name)}</h1>

      <Image height={height} width={width} alt="shop logo" src={shop.logoMedia?.url as string} unoptimized />
    </section>
  );
}

const getComputedImageDimensions = (height: number, media: Media) => {
  const width = Math.round((media.width / media.height) * height);

  return { width, height };
};
